/* ==========================================================================
   PHOEBE'S — theme.js
   Vanilla JS, sin dependencias. Compatible con el editor de temas de Shopify.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';

  /* ---------------------------------------------------------------- utils */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var out = intPart + ',' + parts[1];
    if (moneyFormat.indexOf('without_currency') > -1) return out;
    return out + ' €';
  }
  window.formatMoney = formatMoney;

  var scrollLock = {
    count: 0,
    y: 0,
    lock: function () {
      if (this.count === 0) {
        this.y = window.scrollY;
        document.body.classList.add('is-locked');
        document.body.style.top = '-' + this.y + 'px';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      }
      this.count++;
    },
    unlock: function () {
      this.count = Math.max(0, this.count - 1);
      if (this.count === 0) {
        document.body.classList.remove('is-locked');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, this.y);
      }
    }
  };

  /* ------------------------------------------------------------- overlay */
  var overlay = null;
  function getOverlay() {
    if (!overlay) {
      overlay = $('[data-overlay]');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'overlay';
        overlay.setAttribute('data-overlay', '');
        document.body.appendChild(overlay);
      }
      on(overlay, 'click', function () { closeAllPanels(); });
    }
    return overlay;
  }

  var openPanels = [];

  function openPanel(el) {
    if (!el || openPanels.indexOf(el) > -1) return;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    getOverlay().classList.add('is-active');
    scrollLock.lock();
    openPanels.push(el);
    var focusTarget = el.querySelector('[data-autofocus]') || el.querySelector('button, [href], input, select, textarea');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 260);
  }

  function closePanel(el) {
    if (!el) return;
    var i = openPanels.indexOf(el);
    if (i === -1) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    openPanels.splice(i, 1);
    scrollLock.unlock();
    if (openPanels.length === 0) getOverlay().classList.remove('is-active');
  }

  function closeAllPanels() {
    openPanels.slice().forEach(closePanel);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanels.length) closeAllPanels();
  });

  /* ------------------------------------------------ toggles declarativos */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open]');
    if (openBtn) {
      e.preventDefault();
      var target = document.getElementById(openBtn.getAttribute('data-open'));
      if (target) {
        if (target.classList.contains('is-open')) closePanel(target);
        else { closeAllPanels(); openPanel(target); }
      }
      return;
    }
    var closeBtn = e.target.closest('[data-close]');
    if (closeBtn) {
      e.preventDefault();
      var panel = closeBtn.closest('.drawer, .mobile-nav, .search-panel, .filters-drawer, [data-panel]');
      closePanel(panel);
      return;
    }
    var accBtn = e.target.closest('[data-accordion-toggle]');
    if (accBtn) {
      var acc = accBtn.closest('[data-accordion]');
      if (acc) {
        var isOpen = acc.classList.toggle('is-open');
        accBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }
  });

  /* -------------------------------------------------------------- header */
  function initHeader() {
    var wrap = $('[data-header]');
    if (!wrap) return;
    var last = 0;
    var threshold = 24;

    function onScroll() {
      var y = window.scrollY;
      wrap.classList.toggle('is-scrolled', y > threshold);
      last = y;
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Mega menú: marcar el header como "abierto" para el modo overlay
    $$('[data-mega-parent]', wrap).forEach(function (item) {
      on(item, 'mouseenter', function () { wrap.classList.add('is-open'); });
      on(item, 'mouseleave', function () { wrap.classList.remove('is-open'); });
      on(item, 'focusin', function () { wrap.classList.add('is-open'); });
      on(item, 'focusout', function (e) {
        if (!item.contains(e.relatedTarget)) wrap.classList.remove('is-open');
      });
    });
  }

  /* ------------------------------------------------------ menú móvil */
  function initMobileNav() {
    $$('[data-m-toggle]').forEach(function (btn) {
      on(btn, 'click', function () {
        var item = btn.closest('.m-item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ------------------------------------------------- barra de anuncios */
  function initAnnouncement() {
    $$('[data-announcement]').forEach(function (bar) {
      var slides = $$('.announcement__slide', bar);
      if (slides.length < 2) return;
      var i = 0;
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
      var timer;

      function go(n) {
        slides[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
      }
      function start() { timer = setInterval(function () { go(i + 1); }, interval); }
      function stop() { clearInterval(timer); }

      on($('[data-ann-prev]', bar), 'click', function () { stop(); go(i - 1); start(); });
      on($('[data-ann-next]', bar), 'click', function () { stop(); go(i + 1); start(); });
      on(bar, 'mouseenter', stop);
      on(bar, 'mouseleave', start);
      start();
    });
  }

  /* -------------------------------------------------------- carruseles */
  function initCarousels(ctx) {
    $$('[data-carousel]', ctx || document).forEach(function (car) {
      if (car.dataset.carouselReady) return;
      car.dataset.carouselReady = '1';

      var track = $('[data-carousel-track]', car);
      var prev = $('[data-carousel-prev]', car);
      var next = $('[data-carousel-next]', car);
      var dotsWrap = $('[data-carousel-dots]', car);
      if (!track) return;

      var slides = $$(':scope > *', track);

      function step() {
        var first = slides[0];
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (dotsWrap) {
          var idx = Math.round(track.scrollLeft / step());
          $$('.carousel__dot', dotsWrap).forEach(function (d, n) {
            d.classList.toggle('is-active', n === idx);
          });
        }
      }

      if (dotsWrap && slides.length > 1) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'carousel__dot' + (n === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Ir a la diapositiva ' + (n + 1));
          on(b, 'click', function () { track.scrollTo({ left: step() * n, behavior: 'smooth' }); });
          dotsWrap.appendChild(b);
        });
      }

      on(prev, 'click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      on(next, 'click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      on(track, 'scroll', debounce(update, 60), { passive: true });
      window.addEventListener('resize', debounce(update, 150));
      update();
    });
  }

  /* --------------------------------------------------- galería producto */
  function initGallery(ctx) {
    $$('[data-gallery]', ctx || document).forEach(function (g) {
      var slides = $('[data-gallery-slides]', g);
      var counter = $('[data-gallery-counter]', g);
      var dots = $('[data-gallery-dots]', g);
      if (!slides) return;
      var items = $$(':scope > *', slides);
      if (items.length < 2) return;

      if (dots) {
        dots.innerHTML = '';
        items.forEach(function (_, n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'carousel__dot' + (n === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Imagen ' + (n + 1));
          on(b, 'click', function () { slides.scrollTo({ left: slides.clientWidth * n, behavior: 'smooth' }); });
          dots.appendChild(b);
        });
      }

      on(slides, 'scroll', debounce(function () {
        var idx = Math.round(slides.scrollLeft / slides.clientWidth);
        if (counter) counter.textContent = (idx + 1) + ' / ' + items.length;
        if (dots) $$('.carousel__dot', dots).forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      }, 60), { passive: true });

      if (counter) counter.textContent = '1 / ' + items.length;

      // Miniaturas / selector de media desde variantes
      g.selectMedia = function (mediaId) {
        var idx = items.findIndex(function (it) { return it.getAttribute('data-media-id') === String(mediaId); });
        if (idx > -1) {
          if (window.matchMedia('(min-width: 990px)').matches) {
            items[idx].scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            slides.scrollTo({ left: slides.clientWidth * idx, behavior: 'smooth' });
          }
        }
      };
    });
  }

  /* ------------------------------------------------- variantes producto */
  function initVariants(ctx) {
    $$('[data-product-form]', ctx || document).forEach(function (form) {
      if (form.dataset.variantsReady) return;
      form.dataset.variantsReady = '1';

      var dataEl = $('[data-variants-json]', form.closest('[data-product-root]') || document);
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var root = form.closest('[data-product-root]');
      var idInput = $('[data-variant-id]', form);
      var atc = $('[data-atc]', form);
      var priceEl = $('[data-price]', root);
      var skuEl = $('[data-sku]', root);
      var gallery = $('[data-gallery]', root);

      function currentOptions() {
        var vals = [];
        $$('[data-option-index]', form).forEach(function (input) {
          if (input.type === 'radio') {
            if (input.checked) vals[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
          } else {
            vals[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
          }
        });
        return vals;
      }

      function match(vals) {
        return variants.find(function (v) {
          return vals.every(function (val, i) { return !val || v.options[i] === val; });
        });
      }

      function render() {
        var vals = currentOptions();
        var v = match(vals);

        // etiqueta del valor seleccionado
        $$('[data-option-selected]', form).forEach(function (el) {
          var i = parseInt(el.getAttribute('data-option-selected'), 10);
          el.textContent = vals[i] || '';
        });

        if (!v) {
          if (idInput) idInput.value = '';
          if (atc) { atc.disabled = true; atc.textContent = strings.unavailable || 'No disponible'; }
          return;
        }

        if (idInput) idInput.value = v.id;
        if (priceEl) {
          var html = '<span>' + formatMoney(v.price) + '</span>';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html = '<span class="price--now">' + formatMoney(v.price) + '</span>' +
                   '<s class="price--was">' + formatMoney(v.compare_at_price) + '</s>';
          }
          priceEl.innerHTML = html;
        }
        if (skuEl) skuEl.textContent = v.sku || '';
        if (atc) {
          atc.disabled = !v.available;
          atc.textContent = v.available ? (strings.addToCart || 'Añadir a la cesta') : (strings.soldOut || 'Agotado');
        }
        if (gallery && gallery.selectMedia && v.featured_media) gallery.selectMedia(v.featured_media.id);

        if (history.replaceState && v.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }

      $$('[data-option-index]', form).forEach(function (input) { on(input, 'change', render); });
      render();

      on(form, 'submit', function (e) {
        if (!window.theme || !window.theme.cartDrawer) return;
        e.preventDefault();
        addToCart(form, atc);
      });
    });
  }

  /* --------------------------------------------------------- carrito AJAX */
  function setLoading(btn, state) {
    if (!btn) return;
    if (state) {
      btn.dataset.label = btn.innerHTML;
      btn.innerHTML = '<span class="spinner"></span>';
      btn.disabled = true;
    } else {
      if (btn.dataset.label) btn.innerHTML = btn.dataset.label;
      btn.disabled = false;
    }
  }

  function addToCart(form, btn) {
    setLoading(btn, true);
    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        setLoading(btn, false);
        if (!res.ok) {
          alert(res.data.description || res.data.message || 'Error');
          return;
        }
        refreshCart(true);
      })
      .catch(function () { setLoading(btn, false); });
  }

  function refreshCart(open) {
    return fetch((routes.cart_url || '/cart') + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var current = $('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;

        return fetch((routes.cart_url || '/cart') + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            $$('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle('hide', cart.item_count === 0);
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            if (open) openPanel($('#CartDrawer'));
            return cart;
          });
      });
  }
  window.refreshCart = refreshCart;

  function changeLine(key, qty, row) {
    if (row) row.classList.add('loading');
    fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        refreshCart(false);
      });
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-line-remove]');

    if (minus || plus) {
      var wrap = (minus || plus).closest('.qty');
      var input = $('input', wrap);
      if (!input) return;
      var v = parseInt(input.value, 10) || 0;
      v = plus ? v + 1 : Math.max(0, v - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (remove) {
      e.preventDefault();
      var key = remove.getAttribute('data-line-remove');
      changeLine(key, 0, remove.closest('[data-line]'));
    }
  });

  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-line-qty]');
    if (qtyInput) {
      var key = qtyInput.getAttribute('data-line-qty');
      changeLine(key, parseInt(qtyInput.value, 10) || 0, qtyInput.closest('[data-line]'));
    }
  });

  // Botones "añadir rápido" en tarjetas de producto
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, $('button[type="submit"]', form));
  });

  /* ------------------------------------------------- búsqueda predictiva */
  function initPredictive() {
    var panel = $('#SearchPanel');
    if (!panel) return;
    var input = $('[data-search-input]', panel);
    var results = $('[data-predictive]', panel);
    if (!input || !results) return;

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      fetch((routes.predictive_search_url || '/search/suggest') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article&resources[limit]=6&section_id=predictive-search')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-predictive-inner]');
          results.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(function () { results.innerHTML = ''; });
    }, 260);

    on(input, 'input', run);
  }

  /* -------------------------------------------------- filtros colección */
  function initFilters() {
    var form = $('[data-filters-form]');
    if (!form) return;

    function submitFilters() {
      var params = new URLSearchParams(new FormData(form));
      var url = form.getAttribute('action') + '?' + params.toString();
      fetchCollection(url);
    }

    on(form, 'change', submitFilters);

    $$('[data-sort]').forEach(function (sel) {
      on(sel, 'change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        fetchCollection(url.toString());
      });
    });

    function fetchCollection(url) {
      var grid = $('[data-collection-grid]');
      if (grid) grid.classList.add('loading');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-collection-grid]', '[data-collection-count]', '[data-active-filters]', '[data-filters-form]'].forEach(function (sel) {
            var fresh = doc.querySelector(sel);
            var cur = document.querySelector(sel);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
          if (grid) grid.classList.remove('loading');
          history.pushState({}, '', url);
          initReveal();
        });
    }

    window.addEventListener('popstate', function () { window.location.reload(); });
  }

  /* ------------------------------------------------------------ reveal */
  var io;
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .06 });
    }
    $$('.reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------------- sticky ATC móvil */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    obs.observe(anchor);
  }

  /* ------------------------------------------------------ inicialización */
  function init(ctx) {
    initHeader();
    initMobileNav();
    initAnnouncement();
    initCarousels(ctx);
    initGallery(ctx);
    initVariants(ctx);
    initPredictive();
    initFilters();
    initReveal();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* --------------------------------------------- eventos editor de temas */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var panel = e.target.querySelector('.drawer, .search-panel');
    if (panel) openPanel(panel);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var panel = e.target.querySelector('.drawer, .search-panel');
    if (panel) closePanel(panel);
  });
})();
